export const titleMaxLength = 70;

export const linkMaxLength = 2048;

export const descriptionMaxLength = 250;
